import type { FC } from 'react';
import type { SecurityOptionsTabProps } from '../../types';
import CoHostsSection from '../form-fields/CoHostsSection';
import MeetingSecuritySection from '../form-fields/MeetingSecuritySection';

const SecurityOptionsTab: FC<SecurityOptionsTabProps> = ({
  selectedMeetingData,
  isUpdating,
  updateMeetingData,
}) => (
  <div className="personal-meetings-modal__tab-content">
    <MeetingSecuritySection
      selectedMeetingData={selectedMeetingData}
      isUpdating={isUpdating}
      updateMeetingData={updateMeetingData}
    />

    <CoHostsSection
      selectedMeetingData={selectedMeetingData}
      isUpdating={isUpdating}
      updateMeetingData={updateMeetingData}
    />
  </div>
);

export default SecurityOptionsTab;
